import { useState, useEffect, type ReactNode } from 'react';

export interface KVGridProps {
  children: ReactNode;
  columns?: 1 | 2;
}

export function KVGrid({ children, columns = 1 }: KVGridProps) {
  const [narrow, setNarrow] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia('(max-width: 959px)').matches : false,
  );

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 959px)');
    const handler = (e: MediaQueryListEvent) => setNarrow(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  if (columns === 1 || narrow) {
    return <div>{children}</div>;
  }

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      columnGap: 'var(--evo-space-4)',
      alignItems: 'stretch',
    }}>
      {children}
    </div>
  );
}
